const PULL_FLAG = 'pullAdjustApplied';
const DEFAULT_PULL_AMOUNT = 150;
const CSS_PULL_VARIABLE = '--pull-bottom-offset';

const parsePullValue = (value) => {
  if (value === null || value === undefined) {
    return NaN;
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return NaN;
  }

  const numeric = Number.parseFloat(trimmed);
  return Number.isFinite(numeric) && numeric >= 0 ? numeric : NaN;
};

const resolvePullAmount = (element) => {
  if (!element) {
    return DEFAULT_PULL_AMOUNT;
  }

  const attr = element.getAttribute('data-pull-amount') || element.dataset.pullAmount;
  const inlineValue = parsePullValue(attr);
  if (Number.isFinite(inlineValue)) {
    return inlineValue;
  }

  if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') {
    const styles = window.getComputedStyle(element);
    const variableValue = styles.getPropertyValue(CSS_PULL_VARIABLE);
    const cssValue = parsePullValue(variableValue);
    if (Number.isFinite(cssValue)) {
      return cssValue;
    }
  }

  return DEFAULT_PULL_AMOUNT;
};

const applyPullEffect = (element) => {
  if (!element || element.dataset[PULL_FLAG] === '1') {
    return;
  }

  const contentElement = findTopLevelContentElement(element);
  if (!contentElement) {
    return;
  }

  const nextContentElement = findNextContentElement(contentElement);
  if (!nextContentElement) {
    return;
  }

  const pullAmount = resolvePullAmount(element);
  if (!Number.isFinite(pullAmount) || pullAmount <= 0) {
    return;
  }

  nextContentElement.style.transform = `translateY(-${pullAmount}px)`;
  nextContentElement.style.marginBottom = `calc(-${pullAmount}px + var(--main-gap))`;
  nextContentElement.classList.add('pulled-up-element');
  element.style.paddingBottom = `calc(var(--main-gap) + ${pullAmount}px)`;
  element.dataset[PULL_FLAG] = '1';
};

export function adjustPullElements() {
  const pullElements = document.querySelectorAll('.pull-bottom');
  if (pullElements.length === 0) {
    return;
  }

  const applyImmediately = !('IntersectionObserver' in window);

  if (applyImmediately) {
    pullElements.forEach(applyPullEffect);
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      applyPullEffect(entry.target);
      obs.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -20% 0px',
    threshold: 0,
  });

  pullElements.forEach((element) => {
    if (element.dataset[PULL_FLAG] === '1') {
      return;
    }
    observer.observe(element);
  });
}

function findTopLevelContentElement(element) {
  let contentElement = element.closest('.content--element');
  if (!contentElement) return null;

  let parentContentElement = contentElement.parentElement.closest('.content--element');
  return parentContentElement || contentElement;
}

function findNextContentElement(element) {
  let nextElement = element.nextElementSibling;
  while (nextElement && !nextElement.classList.contains('content--element')) {
    nextElement = nextElement.nextElementSibling;
  }
  return nextElement;
}
